import React from 'react'
import { cn } from '../../lib/utils'

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  fullWidth?: boolean
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  fullWidth = false,
  className,
  ...props
}) => {
  return (
    <button
      className={cn(
        'px-10 py-4 rounded-full font-bold text-lg transition-colors duration-200',
        'hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed',
        fullWidth && 'w-full',
        className
      )}
      style={{ backgroundColor: '#145F6B', color: 'white' }}
      {...props}
    >
      {children}
    </button>
  )
}

